import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense, type ComponentPropsWithoutRef } from "react";

import { PlanTrialOptInModalSkeleton } from "@/react/components/SettingsApp/Plan/PlanTrialOptInModal/PlanTrialOptInModalSkeleton/PlanTrialOptInModalSkeleton";

const PlanTrialOptInModalComponent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "PlanTrialOptInModal" */ "./PlanTrialOptInModalComponent"
  ).then(module => ({ default: module.PlanTrialOptInModalComponent })),
);

const PlanTrialOptInModalUIKitComponent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "PlanTrialOptInModalUIKit" */ "./PlanTrialOptInModalUIKitComponent"
  ).then(module => ({ default: module.PlanTrialOptInModalUIKitComponent })),
);

export const usePlanTrialOptInModal = createCompassModalSwitcher(
  (props: ComponentPropsWithoutRef<typeof PlanTrialOptInModalComponent>) => (
    <Suspense
      fallback={
        <PlanTrialOptInModalSkeleton
          title={props.title}
          onCancel={props.onCancel}
        />
      }
    >
      <PlanTrialOptInModalComponent {...props} />
    </Suspense>
  ),
  (
    props: ComponentPropsWithoutRef<typeof PlanTrialOptInModalUIKitComponent>,
  ) => (
    <Suspense
      fallback={
        <PlanTrialOptInModalSkeleton
          title={props.title}
          onCancel={props.onCancel}
        />
      }
    >
      <PlanTrialOptInModalUIKitComponent {...props} />
    </Suspense>
  ),
);
